import { render, staticRenderFns } from "./DeviceOrganizationParameters.vue?vue&type=template&id=3de64f7e&scoped=true"
import script from "./DeviceOrganizationParameters.vue?vue&type=script&lang=js"
export * from "./DeviceOrganizationParameters.vue?vue&type=script&lang=js"
import style0 from "./DeviceOrganizationParameters.vue?vue&type=style&index=0&id=3de64f7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de64f7e",
  null
  
)

export default component.exports